import styled, { css } from 'styled-components';

import { media, color, fontSize } from 'components/_settings/variables';
import { Container } from 'components/shared/container';
import { Grid as SharedGrid, GridCell } from 'components/shared/grid';
import { Title } from 'components/shared/title';

export const SliderWrapper = styled.div`
  display: none;
  ${media.md} {
    display: block;
  }
  .slick-dots {
    position: absolute;
    bottom: 22px;
    margin: 0;
    padding: 0;
    left: 0;
    right: 0;
    text-align: center;
    li {
      display: inline-block;
      padding: 0 3px;
      button {
        border: none;
        outline: none;
        background-color: #eaeef2;
        text-indent: -9999px;
        overflow: hidden;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        display: block;
        -webkit-appearance: none !important;
        padding: 0;
      }
    }
    li.slick-active {
      button {
        background: #a7aec1;
      }
    }
  }
`;

export const ContentFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 47px 67px 57px 54px;
  box-shadow: inset 0 1px 0 0 #d9dfe4;

  ${media.md} {
    flex-direction: column;
    justify-content: center;
  }

  ${media.sm} {
    padding: 30px 0 44px 0;
  }
`;

export const FooterImg = styled.img`
  ${media.md} {
    display: none;
  }
`;

export const FooterLeft = styled.div`
  display: flex;
  align-items: center;
  ${media.md} {
    flex-direction: column;
  }
`;

export const FooterText = styled.div`
  margin-left: 40px;
  ${media.lg} {
    max-width: 396px;
  }
  ${media.md} {
    margin-top: 20px;
    margin-bottom: 20px;
    max-width: 100%;
    margin-left: 0;
    margin-top: 0;
    margin-bottom: 30px;
  }
`;

export const FooterTitle = styled(Title)`
  font-size: ${fontSize.lg};
  font-weight: normal;
  line-height: 1.33;
  margin-bottom: 12px;
  ${media.md} {
    font-size: 20px;
    line-height: 1.4;
    margin-bottom: 18px;
    text-align: center;
  }
`;

export const FooterDescription = styled.p`
  font-size: 18px;
  line-height: 1.56;
  color: #838791;
  margin: 0;
  ${media.md} {
    font-size: 16px;
    line-height: 1.5;
    text-align: center;
    padding: 0 31px;
  }
`;

export const ItemWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 68px 0 89px;
`;

export const ItemImg = styled.div`
  position: relative;
  height: 64px;
  margin-bottom: 19px;
  ${media.md} {
    display: flex;
    justify-content: center;
  }
  .gatsby-image-wrapper {
    overflow: initial !important;
  }
`;

export const ItemTitle = styled(Title)`
  font-size: 20px;
  font-weight: normal;
  line-height: 1.55;
  color: ${color.text.secondary};
  white-space: pre-wrap;
  margin-bottom: 20px;
  ${media.sm} {
    font-size: 20px;
  }
`;

export const ItemBottomText = styled.span`
  display: block;
  font-size: 12px;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 1px;
  color: #19c7e1;
  text-transform: uppercase;
`;

export const Grid = styled(SharedGrid)`
  ${media.md} {
    display: none;
  }
`;

export const GridItem = styled(GridCell)`
  &:nth-child(2) ${ItemImg} {
    svg {
      margin-top: -12px;
    }
  }
  &:nth-child(3) ${ItemImg} {
    svg {
      margin-top: 8px;
    }
  }
  &:nth-child(4) ${ItemImg} {
    svg {
      margin-top: -17px;
    }
  }
  ${(p) => css`
    ${p.borderRight &&
    css`
      box-shadow: inset -1px 0 0 0 #d9dfe4;
      ${media.md} {
        box-shadow: inset 0 0 1px 0 #d9dfe4;
      }
    `}
  `}
`;

export const Inner = styled(Container)`
  position: relative;
  border-radius: 8px;
  background-color: ${color.text.tertiary};
  box-shadow: 14px 36px 150px -45px rgba(50, 50, 93, 0.5), 2px 2px 12px 0 rgba(26, 26, 67, 0.05);
  @media (min-width: 1378px) {
    max-width: 1318px;
  }
  ${media.md} {
    padding-right: 0;
    padding-left: 0;
  }
`;

export const Wrapper = styled.div`
  position: relative;
`;
